import { Validators } from "@angular/forms";

export const passwordValidators = [
    Validators.required,
    Validators.minLength(8),
    Validators.pattern(/(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^\w\s])/)
]